import { AxiosError } from 'axios';
import { POST_INVALIDATE_UNIQUE_LINK } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

export const usePostInvalidateUniqueLink = ({ onSuccess, onError }: Input = {}) => {
  const postInvalidateUniqueLink = async (token: string) => {
    const res = await axiosClient.post<void>(POST_INVALIDATE_UNIQUE_LINK(token));

    return res.data;
  };

  return useCustomMutation(postInvalidateUniqueLink, {
    onSuccess,
    onError,
  });
};
